export default __webpack_public_path__ + "static/media/user.b3554f13.png";